'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = require('preact');

var ChevronIcon = function ChevronIcon(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color,
      placement = _ref.placement,
      className = _ref.className;

  var rotate = placement === 'bottom' ? '0' : placement === 'top' ? '0' : placement === 'left' ? '-90' : '0';
  return (0, _preact.h)(
    'svg',
    {
      'aria-hidden': true,
      xmlns: 'http://www.w3.org/2000/svg',
      width: width,
      height: height,
      viewBox: '0 0 11 7',
      transform: 'rotate(' + rotate + ')',
      className: className
    },
    (0, _preact.h)('path', { fill: color, 'fill-rule': 'evenodd', d: 'M9.743.793l.707.707L5.5 6.45.55 1.5l.707-.707L5.5 5.036 9.743.793z' })
  );
};

ChevronIcon.defaultProps = {
  width: 11,
  height: 7,
  color: 'currentColor',
  placement: 'bottom'
};

exports.default = ChevronIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Icon/ChevronIcon.js
// module id = 19
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38